import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import {
    Backdrop,
    Checkbox,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormLabel,
    Modal,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from '@mui/material'
import { modalStyle } from '../RegistrationModals'
import { useEffect, useState } from 'react'
import pxToRem from '../../../helpers/pxToRem'
import styles from '../index.module.scss'
import { PrimaryButton } from '../../../components/Button'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import ModalBackdrop from '../../../components/Backdrop'
import { ES_submitHasQualification } from '../../../firebase/teacherApi'
import { setErrorMsg } from '../../../redux/uiSlice'
import { DEFAULT_ERR_MSG } from '../../../helpers/errorMsg'

const ESQualificationModal = () => {
    const employmentSetting = useSelector(
        (state: RootState) => state.userReg.employmentSetting
    )
    const userId = useSelector((state: RootState) => state.user.auth.status?.uid)
    const dispatch = useDispatch()

    const [value, setValue] = useState<boolean>()
    const [loading, setLoading] = useState(false)

    const onSubmit = async () => {
        try {
            setLoading(true)
            if (!userId || !employmentSetting?.id || value === undefined)
                throw new Error()
            await ES_submitHasQualification(userId, employmentSetting.id, value)
        } catch (e) {
            dispatch(setErrorMsg(DEFAULT_ERR_MSG))
        } finally {
            setValue(undefined)
            setLoading(false)
        }
    }

    if (
        employmentSetting?.type === 'supportStaff' &&
        employmentSetting.hasQualification === undefined
    ) {
        return (
            <Modal open={true}>
                <Stack
                    sx={{
                        ...modalStyle,
                        width: pxToRem(600),
                        maxWidth: '90%',
                        height: 'fit-content',
                        p: 6,
                        gap: pxToRem(24),
                        alignItems: 'center',
                        '>*': {
                            textAlign: 'center',
                            fontFamily: 'Lexend Deca',
                        },
                    }}
                >
                    <ModalBackdrop open={loading} />
                    <Typography
                        variant={'h5'}
                        sx={{ color: styles.shades100, fontWeight: '600' }}
                    >
                        Before you start your application
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{ color: styles.shades100 }}
                    >
                        Have you completed any relevant tertiary or other formal
                        qualifications in education? (e.g., certificate,
                        diploma, university degree.)*
                    </Typography>
                    <Stack
                        direction={'row'}
                        gap={pxToRem(12)}
                        alignItems={'center'}
                        sx={{
                            '>div': {
                                flexDirection: 'row',
                                alignItems: 'center',
                            },
                        }}
                    >
                        <FormControlLabel
                            checked={value === true}
                            sx={{
                                color: styles.shades100,
                            }}
                            onChange={() => setValue(true)}
                            control={
                                <Checkbox
                                    icon={
                                        // prettier-ignore
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > {' '} <g clipPath="url(#clip0_660_5685)"> {' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#A3A3A3" />{' '} </g>{' '} <defs> {' '} <clipPath id="clip0_660_5685"> {' '} <rect width="24" height="24" fill="white" />{' '} </clipPath>{' '} </defs>{' '} </svg>
                                    }
                                    checkedIcon={
                                        // prettier-ignore
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > {' '} <g clipPath="url(#clip0_660_7000)"> {' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="#60C1A3" />{' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#60C1A3" />{' '} <path d="M18.6663 7L9.49967 16.1667L5.33301 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />{' '} </g>{' '} <defs> {' '} <clipPath id="clip0_660_7000"> {' '} <rect width="24" height="24" fill="white" />{' '} </clipPath>{' '} </defs>{' '} </svg>
                                    }
                                />
                            }
                            label="Yes"
                        />
                        <FormControlLabel
                            checked={value === false}
                            sx={{
                                color: styles.shades100,
                            }}
                            onChange={() => setValue(false)}
                            control={
                                <Checkbox
                                    icon={
                                        // prettier-ignore
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > {' '} <g clipPath="url(#clip0_660_5685)"> {' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#A3A3A3" />{' '} </g>{' '} <defs> {' '} <clipPath id="clip0_660_5685"> {' '} <rect width="24" height="24" fill="white" />{' '} </clipPath>{' '} </defs>{' '} </svg>
                                    }
                                    checkedIcon={
                                        // prettier-ignore
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > {' '} <g clipPath="url(#clip0_660_7000)"> {' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="#60C1A3" />{' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#60C1A3" />{' '} <path d="M18.6663 7L9.49967 16.1667L5.33301 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />{' '} </g>{' '} <defs> {' '} <clipPath id="clip0_660_7000"> {' '} <rect width="24" height="24" fill="white" />{' '} </clipPath>{' '} </defs>{' '} </svg>
                                    }
                                />
                            }
                            label="No"
                        />
                    </Stack>
                    <Typography
                        variant="caption"
                        sx={{ color: styles.neutrals500 }}
                    >
                        We'll use this to set the right accreditation
                        requirements for you.
                    </Typography>
                    <PrimaryButton
                        onClick={onSubmit}
                        disabled={loading || value === undefined}
                        sx={{ marginTop: pxToRem(24) }}
                    >
                        Continue
                    </PrimaryButton>
                </Stack>
            </Modal>
        )
    }
    return null
}

export default ESQualificationModal
